/**
 * Qué URL de imagen puede pasar por el optimizador de Next.
 *
 * `next/image` **lanza** si el host no está declarado en `remotePatterns` de
 * `next.config.ts`. Como la foto de un vehículo la pone el dato del tenant, una
 * URL de un dominio inesperado dejaría la ficha rota en vez de una foto sin
 * optimizar. Módulo aparte y sin JSX para poder probarlo en
 * `npm run test:foto-optimizada`.
 */
/** Hosts que `next.config.ts` habilita para el optimizador. */
const HOSTS_OPTIMIZABLES = ['.supabase.co', 'images.unsplash.com'];

export function esOptimizable(src?: string | null): boolean {
  if (!src) return false;
  // Relativas (mismo dominio) y data: URIs las maneja Next sin `remotePatterns`.
  if (src.startsWith('/')) return true;
  if (src.startsWith('data:')) return false;
  try {
    const { hostname } = new URL(src);
    return HOSTS_OPTIMIZABLES.some((h) => hostname === h || hostname.endsWith(h));
  } catch {
    return false;
  }
}
